'use strict';

/* eslint max-lines-per-function: 0 */
/* eslint quote-props: 0 */

var links = require('./links'),
    ids = require('./ids');


function autoSave ( enable ) {
    if ( enable ) {
        gSTB.SetEnv('{"lan_noip":"","ipaddr_conf":"","dnsip":""}');
        gSTB.ServiceControl('network', 'restart');
    }
}


function noIpSave ( enable ) {
    if ( enable ) {
        gSTB.SetEnv('{"lan_noip": true}');
        gSTB.ServiceControl('network', 'restart');
    }
}


module.exports = function ( data ) {
    var gettext = links.gettext,
        renders = links.api.renders,
        getter = links.api.getters.environment,
        saver = links.api.savers.environment,
        sections, content;

    sections = [
        {
            id: ids.lan,
            name: gettext('Wired (Ethernet)'),
            description: gettext('Setting up wired access to the Internet or a local area network'),
            icon: 'theme-icon-linked',
            parent: ids.base,
            onsave: function () {
                gSTB.ServiceControl('network', 'restart');
            }
        }
    ];

    switch ( core.device.model ) {
        case 'emulator':
        case 'AndroidAPP':
            content = [
                {
                    id: ids.lanAuto,
                    name: gettext('Auto (DHCP)'),
                    description: gettext('Connecting to a wired network in automatic mode'),
                    icon: '',
                    type: 'option',
                    confirmation: {
                        title: gettext('Confirm changes?'),
                        callback: autoSave
                    },
                    render: renders.confirm,
                    parent: ids.lan
                }
            ];
            break;
        default:
            content = [
                {
                    id: ids.lanAuto,
                    name: gettext('Auto (DHCP)'),
                    description: gettext('Connecting to a wired network in automatic mode'),
                    icon: '',
                    type: 'option',
                    confirmation: {
                        title: gettext('Confirm changes?'),
                        callback: autoSave
                    },
                    render: renders.confirm,
                    parent: ids.lan
                },
                {
                    id: ids.lanManualElement1,
                    name: gettext('IP'),
                    description: gettext('Set-top box IP address'),
                    icon: '',
                    render: renders.input,
                    config: {
                        title: gettext('Enter IP address'),
                        mode: 'number'
                    },
                    type: 'option',
                    advanced: true,
                    environment: {
                        'ipaddr_conf': '0.0.0.0',
                        'lan_noip': ''
                    },
                    prepareForRender: function ( env, callback ) {
                        this.config.value = env['ipaddr_conf'];
                        callback();
                    },
                    prepareForSave: function ( value, callback ) {
                        //TODO check IP
                        // if ( DNS !== read.result.dnsip ) {
                        //     if ( checkIP(DNS) ) {
                        //         saveData.dnsip = DNS;
                        //     } else {
                        //         errors.push('DNS');
                        //     }
                        // }
                        this.environment['ipaddr_conf'] = value;
                        this.environment['lan_noip'] = '';
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    parent: ids.lan
                },
                {
                    id: ids.lanManualElement2,
                    name: gettext('Mask'),
                    description: gettext('The subnet mask in which the set-top box is located'),
                    icon: '',
                    render: renders.input,
                    config: {
                        title: gettext('Enter network mask'),
                        mode: 'number'
                    },
                    type: 'option',
                    advanced: true,
                    environment: {
                        'netmask': '0.0.0.0',
                        'lan_noip': ''
                    },
                    prepareForRender: function ( env, callback ) {
                        this.config.value = env['netmask'];
                        callback();
                    },
                    prepareForSave: function ( value, callback ) {
                        //TODO check mask
                        // if ( DNS !== read.result.dnsip ) {
                        //     if ( checkIP(DNS) ) {
                        //         saveData.dnsip = DNS;
                        //     } else {
                        //         errors.push('DNS');
                        //     }
                        // }
                        this.environment['netmask'] = value;
                        this.environment['lan_noip'] = '';
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    parent: ids.lan
                },
                {
                    id: ids.lanManualElement3,
                    name: gettext('Gateway'),
                    description: gettext('Gateway description'),
                    icon: '',
                    render: renders.input,
                    config: {
                        title: gettext('Enter gateway'),
                        mode: 'number'
                    },
                    type: 'option',
                    advanced: true,
                    environment: {
                        'gatewayip': '0.0.0.0',
                        'lan_noip': ''
                    },
                    prepareForRender: function ( env, callback ) {
                        this.config.value = env['gatewayip'];
                        callback();
                    },
                    prepareForSave: function ( value, callback ) {
                        //TODO check gatewayip
                        // if ( DNS !== read.result.dnsip ) {
                        //     if ( checkIP(DNS) ) {
                        //         saveData.dnsip = DNS;
                        //     } else {
                        //         errors.push('DNS');
                        //     }
                        // }
                        this.environment['gatewayip'] = value;
                        this.environment['lan_noip'] = '';
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    parent: ids.lan
                },
                {
                    id: ids.lanManualElement4,
                    name: gettext('DNS'),
                    description: gettext('DNS server IP address'),
                    icon: '',
                    render: renders.input,
                    config: {
                        title: gettext('Enter DNS server'),
                        mode: 'number'
                    },
                    type: 'option',
                    advanced: true,
                    environment: {
                        'dnsip': '0.0.0.0',
                        'lan_noip': ''
                    },
                    prepareForRender: function ( env, callback ) {
                        this.config.value = env['dnsip'];
                        callback();
                    },
                    prepareForSave: function ( value, callback ) {
                        //TODO check DNS
                        // if ( DNS !== read.result.dnsip ) {
                        //     if ( checkIP(DNS) ) {
                        //         saveData.dnsip = DNS;
                        //     } else {
                        //         errors.push('DNS');
                        //     }
                        // }
                        this.environment['dnsip'] = value;
                        this.environment['lan_noip'] = '';
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    parent: ids.lan
                }
            ];
            break;
    }

    sections.forEach(function ( item ) {
        data.sections.push(item);
    });

    content.forEach(function ( item ) {
        data.options.push(item);
    });

    switch ( core.device.model ) {
        case 'MAG324':
        case 'MAG325':
        case 'MAG349':
        case 'MAG350':
        case 'MAG351':
        case 'MAG352':
        case 'MAG256':
        case 'MAG257':
            break;
        default:
            data.options.push({
                id: ids.lanOptDns,
                name: gettext('No IP'),
                description: gettext('Disables the receipt of an IP address on the network interface'),
                icon: 'theme-icon-network',
                type: 'option',
                advanced: true,
                confirmation: {
                    title: gettext('Confirm changes?'),
                    callback: noIpSave
                },
                render: renders.confirm,
                parent: ids.lan
            });
            break;
    }
};
